import React from "react";
import { SvgIcons } from "@tripian/react";
import { useSelector } from "react-redux";
import ICombinedState from "../../../redux/model/ICombinedState";
import Model from "@tripian/model";
import useAuth from "../../../hooks/useAuth";
import { useGuestUserForSimplyCaribbean } from "../../../hooks/useGuestUserForSimplyCaribbean";
import classes from "./TripAppMenu.module.scss";

/**
 * Travel Guide
 * Trip Plan
 */

interface ITripAppMenu {
  isInTripPlan?: boolean;
  onClickBookings?: () => void;
  onClickOffers?: () => void;
  onClickFavorites?: () => void;
  onClickAddTrip?: () => void;
  sharedTrip?: boolean;
  t: (value: Model.TranslationKey) => string;
}

const TripAppMenu: React.FC<ITripAppMenu> = ({
  isInTripPlan = false,
  onClickBookings,
  onClickOffers,
  onClickFavorites,
  onClickAddTrip,
  sharedTrip,
  t,
}) => {
  const { readOnlyTrip, user } = useSelector((state: ICombinedState) => ({
    readOnlyTrip: state.trip.readOnly,
    user: state.user.user,
  }));

  const { isLoggedIn } = useAuth();

  const isGuestForSimplyCaribbean = useGuestUserForSimplyCaribbean();

  const isVisaFlow = window.tconfig?.ELIGIBILITY_TYPE === "visa";
  const needsVisaRedirect =
    isVisaFlow && user && user.userType !== Model.USER_TYPE.ELIGIBILITY;

  return (
    <>
      {/* DEALS */}
      {window.tconfig.DEALS_PAGE_URL &&
        !(sharedTrip && window.tconfig.WIDGET_THEME_1) &&
        isInTripPlan && (
          <div
            className={`${classes.appNavIconImage} ${classes.tooltip}`}
            onClick={() => window.open(window.tconfig.DEALS_PAGE_URL)}
            role="button"
            tabIndex={0}
          >
            <SvgIcons.Star2 width="22" height="22" />
            <span className={`${classes.iconImageText} hide-s`}>
              {t("trips.myTrips.itinerary.deals.title")}
            </span>
          </div>
        )}
      {/* BOOKINGS */}
      {(window.tconfig.SHOW_RESTAURANT_RESERVATIONS ||
        window.tconfig.SHOW_TOURS_AND_TICKETS) &&
        readOnlyTrip === false &&
        !isGuestForSimplyCaribbean &&
        !(sharedTrip && window.tconfig.WIDGET_THEME_1) &&
        isInTripPlan && (
          <div
            className={`${classes.appNavIconImage} ${classes.tooltip} hide-s md:!flex`}
            onClick={onClickBookings}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}
          >
            <SvgIcons.Bookmark2 />
            <span className={`${classes.iconImageText} hide-s`}>
              {t("trips.myTrips.itinerary.bookings.title")}
            </span>
          </div>
        )}

      {/* OFFERS */}
      {window.tconfig.SHOW_OFFERS &&
        readOnlyTrip === false &&
        !isGuestForSimplyCaribbean &&
        isLoggedIn &&
        isInTripPlan &&
        !(sharedTrip && window.tconfig.WIDGET_THEME_1) && (
          <div
            className={`${classes.appNavIconImage} ${classes.tooltip} ${classes.appNavIconImageHideS}`}
            onClick={onClickOffers}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}
          >
            <SvgIcons.Offer2 />
            <span className={`${classes.iconImageText} hide-s`}>
              {t("trips.myTrips.itinerary.offers.title")}
            </span>
          </div>
        )}
      {/* FAVORITES */}
      {readOnlyTrip === false &&
        !isGuestForSimplyCaribbean &&
        !(sharedTrip && window.tconfig.WIDGET_THEME_1) &&
        isInTripPlan && (
          <div
            className={`${classes.appNavIconImage} ${classes.appNavIconImageHideS} ${classes.tooltip}`}
            onClick={onClickFavorites}
            onKeyPress={() => {}}
            role="button"
            tabIndex={0}
          >
            <SvgIcons.Hearth />
            <span className={classes.iconImageText}>
              {t("trips.myTrips.itinerary.favorites.title")}
            </span>
          </div>
        )}
      {/* ADD TRIP */}
      {isLoggedIn && !isInTripPlan && !needsVisaRedirect && (
        <div
          className="bg-primary-color text-white rounded-[6.25rem] py-3 px-10 hide-s"
          onClick={onClickAddTrip}
          onKeyPress={() => {}}
          role="button"
          tabIndex={0}
        >
          <span className="font-medium text-sm">{t("trips.addTrip")}</span>
        </div>
      )}
    </>
  );
};

export default TripAppMenu;
